import halls from "./halls";
import programs from "./programs";
import works from "./works";

export default {
    halls,
    programs,
    works,
};
